"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVerifyCode = void 0;
var keys_1 = require("../keys");
var useMutation_1 = require("../useMutation");
var react_1 = require("react");
var useVerifyCode = function (_a) {
    var _b = _a === void 0 ? {} : _a, successAction = _b.successAction, errorAction = _b.errorAction;
    var _c = (0, useMutation_1.useMutation)({
        successAction: successAction,
        errorAction: errorAction,
        path: keys_1.VERIFY_CODE,
    }), mutate = _c.mutate, isSubmitting = _c.isSubmitting, error = _c.error, data = _c.data;
    return (0, react_1.useMemo)(function () {
        var _a;
        return ({
            verifyCode: mutate,
            isSubmitting: isSubmitting,
            error: error,
            data: (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.tempToken,
        });
    }, [data, mutate, isSubmitting, error]);
};
exports.useVerifyCode = useVerifyCode;
